import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { IMAGES } from '../data/content';
const includes = ['Acceso inmediato', 'Descarga digital', 'Todos los bonos incluidos'];
const payments = ['VISA', 'Mastercard', 'Amex', 'Mercado Pago'];
export function Offer() {
  return <section id="oferta" className="w-full bg-green-soft/40 py-16 sm:py-24" data-id="element-93" data-mp="tzmoxnrgkl7n">
      <div className="mx-auto max-w-5xl px-5" data-id="element-94" data-mp="p0jvz1or65g1">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-1 overflow-hidden rounded-[2rem] border border-beige bg-white shadow-2xl lg:grid-cols-2" data-id="element-95" data-mp="p1uyyzadj963">
          {/* Left — mockup */}
          <div className="relative flex items-center justify-center bg-beige/60 p-8 sm:p-12" data-id="element-96" data-mp="2acbiqs9dyr0m">
            <div className="absolute left-5 top-5 rounded-full bg-green-brand px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-97" data-mp="pj5ucnay2gdh">
              50% OFF
            </div>
            <img src={IMAGES.offerBundle} alt="Paquete completo: guía de 250 recetas más 6 bonos" className="w-full max-w-sm rounded-2xl object-cover shadow-lg" data-id="element-98" data-mp="zi53s83jag1j" />
          </div>

          {/* Right — offer */}
          <div className="p-8 sm:p-12" data-id="element-99" data-mp="bstyqef5hzhl">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow-soft px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-[#C08A2D]" data-id="element-100" data-mp="btvkpdxpg6e3">
              <ZapIcon className="h-3.5 w-3.5" data-id="element-101" data-mp="kkvvo2q0gxn4" /> Oferta por tiempo limitado
            </span>
            <h2 className="mt-4 font-display text-3xl font-black leading-tight text-green-deep sm:text-4xl" data-id="element-102" data-mp="3k8lzsqx37x0z">
              La Guía de las Viandas Escolares
            </h2>

            <div className="mt-6 flex items-end gap-3" data-id="element-103" data-mp="3o84lhowqgc4v">
              <span className="font-display text-2xl font-bold text-[#9AA093] line-through" data-id="element-104" data-mp="vez3ewszbp4k">
                $27.980
              </span>
              <span className="font-display text-5xl font-black text-green-brand" data-id="element-105" data-mp="qge0uqq98tcy">
                $13.990
              </span>
            </div>

            <ul className="mt-6 space-y-2.5" data-id="element-106" data-mp="105xk3xhvqp8c">
              {includes.map(item => <li key={item} className="flex items-center gap-2.5" data-id="element-107" data-mp="cgmoeufdzl12">
                  <span className="flex h-5 w-5 items-center justify-center rounded-full bg-green-brand" data-id="element-108" data-mp="ciz7jawvs1fp">
                    <CheckIcon className="h-3.5 w-3.5 text-white" data-id="element-109" data-mp="7k4qadekakxp" />
                  </span>
                  <span className="text-[15px] font-semibold text-[#3A463A]" data-id="element-110" data-mp="lfgioe58vzbg">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-111" data-mp="1wvygoiohqa07">
              <CTAButton className="w-full" data-id="element-112" data-mp="1wv58redspegh">Comprar ahora — $13.990</CTAButton>
            </div>

            <div className="mt-5 flex items-center justify-center gap-2 text-sm font-semibold text-[#5A6656]" data-id="element-113" data-mp="1sul6xxia1mo0">
              <LockIcon className="h-4 w-4 text-green-brand" data-id="element-114" data-mp="20dcgkk4wwp0e" />
              Compra 100% segura y encriptada
            </div>

            <div className="mt-4 flex flex-wrap items-center justify-center gap-2" data-id="element-115" data-mp="1qghj84kdkunp">
              {payments.map(p => <span key={p} className="rounded-md border border-beige bg-cream px-2.5 py-1 text-[11px] font-bold text-[#5A6656]" data-id="element-116" data-mp="1verd8bud5p7q">
                  {p}
                </span>)}
            </div>
          </div>
        </motion.div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="mx-auto mt-10 flex max-w-3xl flex-col items-center gap-6 rounded-3xl border border-beige bg-white p-8 text-center shadow-sm sm:flex-row sm:text-left" data-id="element-117" data-mp="29ek8mkgu4tm1">
          <div className="flex h-24 w-24 shrink-0 flex-col items-center justify-center rounded-full border-4 border-green-brand bg-green-soft text-green-deep" data-id="element-118" data-mp="1j7frmx00xtin">
            <ShieldCheckIcon className="h-8 w-8" data-id="element-119" data-mp="1988heiol6ezr" />
            <span className="font-display text-sm font-black leading-none" data-id="element-120" data-mp="19900wv4wsm9o">7 días</span>
          </div>
          <div data-id="element-121" data-mp="14aoqai6si7qe">
            <h3 className="font-display text-xl font-bold text-green-deep" data-id="element-122" data-mp="14aykyj2s532f">
              Garantía de satisfacción de 7 días
            </h3>
            <p className="mt-2 text-[15px] leading-relaxed text-[#5A6656]" data-id="element-123" data-mp="1wx9h9hjcshtf">
              Descubrí las recetas con total tranquilidad. Si dentro del plazo sentís
              que el contenido no es para vos, escribinos y te devolvemos el 100% de tu
              dinero. Sin preguntas incómodas, sin vueltas y sin riesgos.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}